import React, { useEffect, useState } from 'react';
import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink,
  sendSignInLinkToEmail
} from "firebase/auth";
import Auth from './Auth';
import * as gtag from '../../../lib/google/gtag';
import { encrypt } from '../../utils/encryptionUtils';
import useAuth from '../../hook/auth';
import { useRouter } from 'next/router';

const storeEncryptedCredentials = async (userCred, expiry) => {
  const { photoURL, reloadUserInfo, metadata, providerData, accessToken } = userCred || {}
  const encryptedUserCred = await encrypt(userCred);
  const encryptedPhotoURL = await encrypt(photoURL);
  const encryptedMetadata = await encrypt(metadata);
  const encryptedProviderData = await encrypt(providerData);
  const encryptedReloadUserInfo = await encrypt(reloadUserInfo);

  window.localStorage.setItem("userCred", encryptedUserCred);
  window.localStorage.setItem("userphotoURL", encryptedPhotoURL);
  window.localStorage.setItem("usermetadata", encryptedMetadata);
  window.localStorage.setItem("userproviderData", encryptedProviderData);
  window.localStorage.setItem("userreloadUserInfo", encryptedReloadUserInfo);
  window.localStorage.setItem("useraccessToken", accessToken);
  window.localStorage.setItem("userCredExpiry", expiry);
  window.localStorage.setItem('userCredTime', Date.now());
};

const removeEncryptedCredentials = () => {
  // window.localStorage.removeItem('emailForSignIn');

  window.localStorage.removeItem('useraccessToken');
  window.localStorage.removeItem("userCred");
  window.localStorage.removeItem("userCredExpiry");
  window.localStorage.removeItem("userphotoURL");
  window.localStorage.removeItem("usermetadata");
  window.localStorage.removeItem("userproviderData");
  window.localStorage.removeItem("userreloadUserInfo");
  window.localStorage.removeItem('userCredTime');
};

export default function Authentication(props) {
  const auth = getAuth();
  const router = useRouter();
  const { setUser } = useAuth() || {};
  const [email, setEmail] = React.useState(typeof window != "undefined" && window.localStorage.getItem("emailForSignIn") || "");
  const [errorResponse, setErrorResponse] = useState("");
  const [checkinboxpop, setCheckinboxpop] = React.useState(false);
  const expiryDuration = 60 * 60 * 1000;

  useEffect(() => {
    const handleSignInWithEmailLink = async () => {
      try {
        if (isSignInWithEmailLink(auth, window.location.href)) {
          let email = window.localStorage.getItem('emailForSignIn');
          if (!email) {
            email = window.prompt('Please provide your email for confirmation');
          }
          const result = await signInWithEmailLink(auth, email, window.location.href);
          if (result && result.user) {
            const expiry = Date.now() + expiryDuration;
            await storeEncryptedCredentials(result.user, expiry);
            setUser(result.user);
            const from = router.query.from || '/';
            router.push(from);
          } else {
            setUser(null);
            setErrorResponse('No user information available in the result.');
          }
        }
      } catch (error) {
        console.error("signInWithEmailLink error:", error);
        switch (error.code) {
          case 'auth/invalid-action-code':
            const shouldReload = window.confirm('There was an error with the sign-in link. Please try to login again.');
            if (shouldReload) {
              removeEncryptedCredentials();
              window.location.reload();
            }
            break;
          default:
            setErrorResponse(`${error}`);
            removeEncryptedCredentials();
            break;
        }
      }
    };

    handleSignInWithEmailLink();
  }, []);

  const clearError = () => {
    if (errorResponse != "") {
      setErrorResponse("");
    }
  };

  const updateEmail = (e) => {
    clearError();
    setEmail(e.target.value);
  };

  const tryPasswordlessSignIn = async (event) => {
    event.preventDefault();
    if (isSignInWithEmailLink(auth, window.location.href)) {
      signInWithEmailLink(auth, email, window.location.href)
        .then((result) => {
          window.localStorage.removeItem('emailForSignIn');
          setCheckinboxpop(true);
        })
    }
    else {
      sendSignInLinkToEmail(auth, email, {
        url: `${window.location.origin}/auth`,
        handleCodeInApp: true,
      })
        .then((result) => {
          gtag.event({
            action: "login",
            method: "EmailAndPassword"
          });
          window.localStorage.setItem("emailForSignIn", email);
          setCheckinboxpop(true);
        })
        .catch((err) => {
          switch (err.code) {
            default:
              setErrorResponse(`${err}`);
          }
        });
    }
  };

  return (
    <>
      <Auth
        {...props}
        pricePlans={props?.pricePlans}
        isPopup={props?.isPopup}
        updateEmail={updateEmail}
        tryPasswordlessSignIn={tryPasswordlessSignIn}
        errorResponse={errorResponse}
        savedEmail={email}
        checkinboxpop={checkinboxpop}
        setCheckinboxpop={setCheckinboxpop}
      />
    </>
  );
}
